import theme from '@/style';
import {View} from 'react-native';
import {useInnerStyle} from '../invitation.style.hooks';
import LazyImage from '@/components/basic/image';
import {
  invitationImcomeIcon,
  invitationPeopleIcon,
  rightIcon,
} from '../invitation.variables';
import React from 'react';
import {useTranslation} from 'react-i18next';
import Text from '@/components/basic/text';
import {toPriceStr} from '@/utils';
import {RecordIcon, RulesIcon} from '../svg.variables';
import {NativeTouchableOpacity} from '@/components/basic/touchable-opacity';
import Button from '@/components/basic/button';
import {UserTotal} from '../invitation.type';
import {StyleSheet} from 'react-native';

export interface InvitationInfoProps {
  onRule?: () => void;
  onRecord?: () => void;
  onAgency?: () => void;
  userTotal?: UserTotal;
  agent: boolean;
  completeCount: number;
}

const InvitationInfo: React.FC<InvitationInfoProps> = ({
  onRule,
  onRecord,
  onAgency,
  agent,
  completeCount,
  userTotal,
}) => {
  const {homeStyle} = useInnerStyle();
  const {t} = useTranslation();
  return (
    <View
      style={[
        homeStyle.contentInner,
        theme.flex.col,
        theme.background.white,
        styles.card,
      ]}>
      <View style={[theme.flex.col, homeStyle.infoUpItem]}>
        <View style={[theme.flex.row]}>
          <View
            style={[
              theme.flex.flex1,
              theme.flex.col,
              theme.flex.alignStart,
              styles.metricItem,
            ]}>
            <View style={[theme.flex.row, theme.flex.centerByCol]}>
              <LazyImage
                imageUrl={invitationImcomeIcon}
                width={theme.iconSize.l}
                height={theme.iconSize.l}
                occupancy="#0000"
              />
              <Text
                second
                fontSize={theme.fontSize.xs}
                fontWeight="500"
                style={[theme.margin.lefts, styles.metricTitle]}>
                {t('invitation.home.income')}
              </Text>
            </View>
            <Text
              main
              blod
              fontFamily="fontDinBold"
              fontSize={24}
              style={[theme.margin.tops, styles.metricValue]}>
              {toPriceStr(userTotal?.bonusAmountTotal || 0, {
                thousands: true,
                fixed: 0,
              })}
            </Text>
          </View>
          <View
            style={[
              theme.flex.flex1,
              homeStyle.infoUpSubItemRight,
              theme.flex.col,
              theme.flex.alignEnd,
              styles.metricItem,
            ]}>
            <View
              style={[theme.flex.row, theme.flex.centerByCol, styles.rightTop]}>
              <LazyImage
                imageUrl={invitationPeopleIcon}
                width={theme.iconSize.l}
                height={theme.iconSize.l}
                occupancy="#0000"
              />
              <Text
                second
                fontSize={theme.fontSize.xs}
                fontWeight="500"
                style={[theme.margin.lefts, styles.metricTitle]}>
                {t('invitation.home.count')}
              </Text>
            </View>
            <Text
              main
              blod
              fontFamily="fontDinBold"
              fontSize={24}
              style={[theme.margin.tops, styles.metricValue]}>
              {userTotal?.invitedNumberTotal || 0}
            </Text>
          </View>
        </View>
        {!agent && completeCount >= 3 && (
          <View style={[theme.flex.col, styles.joinWrap]}>
            <Button radius={40} type="linear-primary" onPress={onAgency}>
              <View style={[theme.flex.col, theme.flex.center]}>
                <Text
                  color={theme.basicColor.white}
                  blod
                  fontSize={theme.fontSize.m}>
                  {t('invitation.home.join')}
                </Text>
                <Text
                  color={theme.basicColor.white}
                  fontSize={theme.fontSize.xs}>
                  {t('invitation.home.join-tip')}
                </Text>
              </View>
            </Button>
          </View>
        )}
      </View>

      <View style={[theme.flex.row, theme.flex.between, styles.bottomActions]}>
        <NativeTouchableOpacity
          style={[
            theme.flex.row,
            theme.flex.centerByCol,
            theme.flex.between,
            styles.actionItem,
          ]}
          onPress={onRecord}>
          <RecordIcon width={theme.iconSize.l} height={theme.iconSize.l} />
          <Text
            second
            fontSize={theme.fontSize.xs}
            style={[theme.margin.lrs, homeStyle.infoBottomText]}>
            {t('invitation.home.record')}
          </Text>
          <LazyImage
            imageUrl={rightIcon}
            width={14}
            height={14}
            occupancy="#0000"
          />
        </NativeTouchableOpacity>
        <NativeTouchableOpacity
          style={[
            theme.flex.row,
            theme.flex.centerByCol,
            theme.flex.between,
            styles.actionItem,
          ]}
          onPress={onRule}>
          <RulesIcon width={theme.iconSize.l} height={theme.iconSize.l} />
          <Text
            second
            fontSize={theme.fontSize.xs}
            style={[theme.margin.lrs, homeStyle.infoBottomText]}>
            {t('invitation.home.reward-rules')}
          </Text>
          <LazyImage
            imageUrl={rightIcon}
            width={14}
            height={14}
            occupancy="#0000"
          />
        </NativeTouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    paddingHorizontal: 24,
    paddingTop: 12,
    paddingBottom: 12,
  },
  metricItem: {
    width: 112,
    minHeight: 67,
  },
  metricTitle: {
    width: 80,
  },
  metricValue: {
    lineHeight: 28,
    letterSpacing: 0,
  },
  rightTop: {
    left: 6,
  },
  joinWrap: {
    marginTop: 12,
  },
  bottomActions: {
    minHeight: 28,
  },
  actionItem: {
    width: 143,
    height: 28,
  },
});

export default InvitationInfo;
